module.exports = __webpack_public_path__ + "media/images/application/template/queens-trade-be7946aae078404987f26fc03b2fbab7.svg";